export const ADMIN_OPERATIONAL_STALE_MS = 30 * 1000;
export const ADMIN_REFERENCE_STALE_MS = 60 * 1000;
export const ADMIN_SESSION_STALE_MS = 5 * 60 * 1000;

export const adminKeys = {
  all: ['admin'] as const,
  session: () => [...adminKeys.all, 'session'] as const,
  dashboard: () => [...adminKeys.all, 'dashboard'] as const,
  dashboardMetrics: () => [...adminKeys.dashboard(), 'metrics'] as const,
  dashboardActivity: () => [...adminKeys.dashboard(), 'activity'] as const,
  providers: () => [...adminKeys.all, 'providers'] as const,
  providersList: (params?: unknown) =>
    [...adminKeys.providers(), 'list', params] as const,
  providerHealth: () => [...adminKeys.providers(), 'health'] as const,
  providerHealthList: (params?: unknown) =>
    [...adminKeys.providerHealth(), 'list', params] as const,
  providerDetail: (providerId: string) =>
    [...adminKeys.providers(), 'detail', providerId] as const,
  providerActivity: (providerId: string, range: string) =>
    [...adminKeys.providerDetail(providerId), 'activity', range] as const,
  providerOnboardingHealth: (providerId: string) =>
    [...adminKeys.providerDetail(providerId), 'onboarding-health'] as const,
  shops: () => [...adminKeys.all, 'shops'] as const,
  shopsList: (params?: unknown) => [...adminKeys.shops(), 'list', params] as const,
  subscriptions: () => [...adminKeys.all, 'subscriptions'] as const,
  subscriptionsList: (params?: unknown) =>
    [...adminKeys.subscriptions(), 'list', params] as const,
  payments: () => [...adminKeys.all, 'payments'] as const,
  paymentsList: (params?: unknown) =>
    [...adminKeys.payments(), 'list', params] as const,
  reviews: () => [...adminKeys.all, 'reviews'] as const,
  reviewsList: (params?: unknown) =>
    [...adminKeys.reviews(), 'list', params] as const,
  imageModeration: () => [...adminKeys.all, 'image-moderation'] as const,
  imageModerationList: (params?: unknown) =>
    [...adminKeys.imageModeration(), 'list', params] as const,
  imageModerationPreview: (assetId: string) =>
    [...adminKeys.imageModeration(), 'preview', assetId] as const,
  serviceCatalog: () => [...adminKeys.all, 'service-catalog'] as const,
  serviceCategories: () =>
    [...adminKeys.serviceCatalog(), 'categories'] as const,
  serviceCategoryDetail: (categoryId: string) =>
    [...adminKeys.serviceCategories(), 'detail', categoryId] as const,
  serviceTemplates: () =>
    [...adminKeys.serviceCatalog(), 'templates'] as const,
  serviceTemplatesAll: () => [...adminKeys.serviceTemplates(), 'all'] as const,
  serviceTemplatesByCategory: (categoryId: string) =>
    [...adminKeys.serviceTemplates(), 'category', categoryId] as const,
  serviceTemplateDetail: (templateId: string) =>
    [...adminKeys.serviceTemplates(), 'detail', templateId] as const,
  auditLogs: () => [...adminKeys.all, 'audit-logs'] as const,
  auditLogsList: (params?: unknown) =>
    [...adminKeys.auditLogs(), 'list', params] as const,
};
